import React, { useEffect, useState, useRef } from 'react';
import { Accordion, Badge, Button, Card, ListGroup, Spinner, Modal } from 'react-bootstrap';
/* import { FaCircle } from 'react-icons/fa'; */
import api from '../../api/axios';
import ComandaTicket from './ComandaTicket';
import ReactToPrint from 'react-to-print';

 const PedidosEmitidosView = () => {
  
  const componentRef = useRef();
    const [pedidosPorMesa, setPedidosPorMesa] = useState({});
  const [loading, setLoading] = useState(true);
  const business = JSON.parse(localStorage.getItem('business'));
  const [showModal, setShowModal] = useState(false);
  const [pedidoAImprimir, setPedidoAImprimir] = useState(null);

/*   useEffect(() => {
    fetchPedidosEmitidos();
  }, []);
 */
useEffect(() => {
  fetchPedidosEmitidos(); // función que ya usás para traer los pedidos

  const interval = setInterval(() => {
    fetchPedidosEmitidos();
  }, 5000); // cada 5 minutos

  return () => clearInterval(interval); // limpieza
}, []);


const fetchPedidosEmitidos = async () => {
  try {
    const [resEmitidos, resPendientes] = await Promise.all([
      api.get('/pedidos/emitidos-por-mesa', {
        params: { business_id: business.id }
      }),
      api.get('/pedidos/activos-por-mesa', {
        params: { business_id: business.id }
      })
    ]);

    const combinados = {};

    // Cargar emitidos primero
    for (const [mesaId, pedidos] of Object.entries(resEmitidos.data)) {
      combinados[mesaId] = pedidos;
    }

    // Agregar pendientes (no emitidos)
    for (const [mesaId, pedidos] of Object.entries(resPendientes.data)) {
      if (!combinados[mesaId]) combinados[mesaId] = {};

      for (const [pedidoId, pedido] of Object.entries(pedidos)) {
        combinados[mesaId][pedidoId] = pedido;
      }
    }

    setPedidosPorMesa(combinados);
  } catch (err) {
    console.error('Error al obtener pedidos:', err);
  } finally {
    setLoading(false);
  }
};


  const handleEmitirComanda = async (pedidoId) => {
  try {
    await api.patch(`/pedidos/${pedidoId}/emitir`);
    const mesaActualizada = await api.get('/pedidos/emitidos-por-mesa', {
      params: { business_id: business.id }
    });

    // Buscamos el pedido emitido para mostrarlo en el modal
    let pedido = null;

for (const [mesaId, pedidos] of Object.entries(mesaActualizada.data)) {
  for (const p of Object.values(pedidos)) {
    if (p.pedido_id === pedidoId) {
      pedido = { ...p, mesa_id: mesaId }; // ← Aseguramos incluir el número de mesa
      break;
    }
  }
  if (pedido) break; // cortamos el bucle si ya encontramos
}


    setPedidoAImprimir(pedido);
    setShowModal(true);

    await fetchPedidosEmitidos(); // refrescamos el listado
  } catch (err) {
    console.error('Error al emitir comanda:', err);
  }
};


  if (loading) return <Spinner animation="border" className="mt-4" />;


const handleEliminarPedido = async (pedidoId) => {
  const confirmar = window.confirm('¿Seguro que querés eliminar este pedido? Esta acción no se puede deshacer.');
  if (!confirmar) return;

  try {
    await api.delete(`/pedidos/${pedidoId}/eliminar-pedido`);
    await fetchPedidosEmitidos(); // actualiza la vista
  } catch (error) {
    console.error('Error al eliminar pedido:', error);
    alert('Hubo un error al intentar eliminar el pedido.');
  }
};




return (
  <>
{/*     <div className="d-flex justify-content-end mb-2">
      <Button variant="outline-primary" size="sm" onClick={fetchPedidosEmitidos}>
        Actualizar manualmente
      </Button>
    </div> */}

    <Accordion defaultActiveKey="0">
      {Object.entries(pedidosPorMesa).map(([mesaId, pedidos], idx) => {
        // 👇 Esta línea es clave
        const tienePendientes = Object.values(pedidos).some(p => !p.is_emitted);

        return (
          <Accordion.Item eventKey={idx.toString()} key={mesaId}>
            <Accordion.Header>
              <strong>Mesa {mesaId}</strong>{' '}
              <Badge bg="secondary" className="ms-2">
                {Object.keys(pedidos).length} pedido/s
              </Badge>
              {tienePendientes && (
                <Badge bg="warning" text="dark" className="ms-2">
                  Pendiente
                </Badge>
              )}
            </Accordion.Header>

            <Accordion.Body>
<Accordion>
  {Object.values(pedidos).map((pedido, subIdx) => (
    <Accordion.Item eventKey={subIdx.toString()} key={pedido.pedido_id}>
      <Accordion.Header>
        <span
          style={{
            display: 'inline-block',
            width: '10px',
            height: '10px',
            borderRadius: '50%',
            backgroundColor: pedido.is_emitted ? 'green' : 'orange',
            marginRight: '8px'
          }}
        ></span>
        <strong>Pedido #{pedido.pedido_id}</strong> -{' '}
        {new Date(new Date(pedido.created_at).getTime() - new Date(pedido.created_at).getTimezoneOffset() * 60000)
  .toLocaleTimeString('es-AR', { hour: '2-digit', minute: '2-digit' })}
      </Accordion.Header>

      <Accordion.Body>
        <ListGroup variant="flush">
          {pedido.items.map((item, idx) => (
            <ListGroup.Item key={idx}>
              <div className="d-flex justify-content-between">
                <div>
                  <strong>
                    {item.cantidad} x {item.nombre}
                  </strong>
                  {item.observacion && (
                    <div className="text-muted small">
                      ({item.observacion})
                    </div>
                  )}
                </div>
{/*                 <div>${item.precio_unitario * item.cantidad}
                    

                </div> */}



              </div>
            </ListGroup.Item>
          ))}
        </ListGroup>

{pedido.is_emitted && (
  <div className="text-end mt-2 d-flex justify-content-end gap-2">
<Button
      size="sm"
      variant="danger"
      onClick={() => handleEliminarPedido(pedido.pedido_id)}
    >
      Eliminar
    </Button>
<Button
    size="sm"
    variant="outline-primary"
    className="ms-2"
    onClick={() => {
      setPedidoAImprimir(pedido);
      setShowModal(true);
    }}
  >
    Reimprimir
  </Button>
</div>
)}


{!pedido.is_emitted && (
  <div className="text-end mt-2 d-flex justify-content-end gap-2">
    <Button
      size="sm"
      variant="danger"
      onClick={() => handleEliminarPedido(pedido.pedido_id)}
    >
      Eliminar
    </Button>
    <Button
      size="sm"
      variant="warning"
      onClick={() => handleEmitirComanda(pedido.pedido_id)}
    >
      Emitir comanda
    </Button>
  </div>
)}

      </Accordion.Body>
    </Accordion.Item>
  ))}
</Accordion>
            </Accordion.Body>
          </Accordion.Item>
        );
      })}
    </Accordion>
<Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
  <Modal.Header closeButton>
    <Modal.Title>Comanda - Pedido #{pedidoAImprimir?.pedido_id}</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {pedidoAImprimir ? (
      <>
        <p><strong>Mesa:</strong> {pedidoAImprimir.mesa_id}</p>
        <p><strong>Hora:</strong> {new Date(pedidoAImprimir.created_at).toLocaleTimeString()}</p>
        <p><strong>Mozo:</strong> {pedidoAImprimir.mozo || 'Sin asignar'}</p>
        <hr />
        <ListGroup>
          {pedidoAImprimir.items.map((item, idx) => (
            <ListGroup.Item key={idx}>
              <strong>{item.cantidad} x {item.nombre}</strong>
              {item.observacion && (
                <div className="text-muted small">({item.observacion})</div>
              )}
            </ListGroup.Item>
          ))}
        </ListGroup>
      </>
    ) : (
      <p>Cargando comanda...</p>
    )}
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowModal(false)}>
      Cerrar
    </Button>
    <ReactToPrint
  trigger={() => (
    <Button variant="primary">
      Imprimir
    </Button>
  )}
  content={() => componentRef.current}
/>

  </Modal.Footer>
</Modal>
<div style={{ display: 'none' }}>
  <ComandaTicket ref={componentRef} pedido={pedidoAImprimir} />
</div>


  </>
);

};

export default PedidosEmitidosView;
